import { forwardRef, useImperativeHandle, useRef } from 'react';
import type { WebinarResource } from '@/features/webinar/types';

export type VideoViewHandle = {
  play: () => void;
  pause: () => void;
  mute: () => void;
  unmute: () => void;
  seek: (time: number) => void;
};

const VideoView = forwardRef<VideoViewHandle, { video: WebinarResource }>(function VideoView(
  { video },
  ref,
) {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useImperativeHandle(ref, () => ({
    play: () => {
      videoRef.current?.play().catch(() => {});
    },
    pause: () => {
      videoRef.current?.pause();
    },
    mute: () => {
      if (videoRef.current) {
        videoRef.current.muted = true;
      }
    },
    unmute: () => {
      if (videoRef.current) {
        videoRef.current.muted = false;
      }
    },
    seek: (time: number) => {
      if (videoRef.current && Number.isFinite(time)) {
        videoRef.current.currentTime = time;
      }
    },
  }));

  return (
    <div className="w-full relative rounded-2xl overflow-hidden">
      <video
        ref={videoRef}
        className="w-full h-auto"
        src={video.resourceUrl}
        controls={false}
        preload="metadata"
        onError={() => {
          console.warn('Erreur de chargement de la vidéo:', video.fileName);
        }}
      />
    </div>
  );
});

export default VideoView;
